import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { alertError, alertSuccess } from "../../../../../utils/logger";
import ConfirmDialog from "../../../../components/dialogs/ConfirmDialog";
import Table, {
	buttonsStyle,
} from "../../../../components/tables/table";
import EditPatientForm from "./EditPatientForm";
import { getForms } from "../../../../../api/form";
import { actualizeFormsUser } from "../../../../../api/user";
import { deleteFormResponse, getFormResponsesByUserId, updateFormResponse } from "../../../../../api/formResponses";
import EditPatientResponseForm from "./EditPatientResponseForm";

const initialFilters = {
	initUpload: null,
  endUpload: null,
  initDoc: null,
  endDoc: null,
  tag: null
}

function dateFormatter(dateString) {
  const date = new Date(dateString);

  return date.toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false, // Para formato 24 horas
  }).replace(',', ' at');
}

export default function EditPatientForms(props) {
  const { userId, patient, refreshPatient } = props;
	const [data, setData] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(-1);
  const [selectedForm, setSelectedForm] = useState(null);
  const [openEditPatientForm, setOpenEditPatientForm] = useState(false);
  const [newForm, setNewForm] = useState(false);
  const [allForms, setAllForms] = useState([]);
  
  const [selectedResponseForm, setSelectedResponseForm] = useState(null);
  const [openEditPatientResponseForm, setOpenEditPatientResponseForm] = useState(false);
  const [formResponses, setFormResponses] = useState([]);

	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

  function getEmptyUserForms() {
    return {
      userId: userId,
      forms: [],
      active: true
    } 
  }

  function getEmptyForm() {
    const newDate = new Date();
    const formatDate = new Date(newDate.getTime() - newDate.getTimezoneOffset() * 60000).toISOString().split('.')[0];
    
    return {
      date: formatDate,
      schedule: null,
      active: true
    }
  }

  useEffect(() => {
    setData(patient?.forms || []);
  }, [patient])

  useEffect(() => {
    getForms()
      .then((res) => {
        setAllForms(res.data)
      })
      .catch((error) => {
        alertError({error, customMessage: "Could not get forms."});
      })
  }, [])

  function fetchResponses() {
    getFormResponsesByUserId(userId)
      .then((res) => {
        setFormResponses(res.data);
        setRefresh(true);
      })
      .catch((error) => {
        if (error.request.status !== 404) {
          alertError({error, customMessage: "Could not get patient responses."})
        }
      })
  }

  useEffect(() => {
    if (!openEditPatientResponseForm) fetchResponses();
  }, [openEditPatientResponseForm])

  useEffect(() => {
    setRefresh(false);
  }, [refresh]);

	const columns = [
		{
			dataField: "name",
			text: "form",
			sort: true,
		},
		{
			dataField: "schedule",
			text: "Schedule",
		},
		{ 
      dataField: "form", 
      text: "", 
      align: 'right',
      headerStyle: { width: '200px' },
      formatter: buttonFormatter
    },
	];

	const responsesColumns = [
		{
			dataField: "name",
			text: "form",
			sort: true,
		},
		{
			dataField: "updatedAt",
			text: "Answered at",
      formatter: dateFormatter,
      sort: true,
		},
		{
			dataField: "createdAt",
			text: "Created at",
      formatter: dateFormatter,
      sort: true,
		},
		{ 
      dataField: "_id", 
      text: "", 
      align: 'right',
      headerStyle: { width: '200px' },
      formatter: responsesButtonFormatter
    },
	];

  function buttonFormatter(cell, row) {
		const index = data?.findIndex((item) => item?.form === row?.form);
    const elem = (index !== -1)? data[index] : null;
    
		return (
			<>
        
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
              setSelectedForm(elem);
              setOpenEditPatientForm(true);
              setNewForm(false);
            }}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes("admin") && (
					<>
						<Tooltip title={elem?.active ? "Disable" : "Enable"}>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={async () => {
                  let newForms = data ? [...data] : [];
                  newForms[index].active = !elem?.active;
                  const res = await actualizeFormsUser(userId, newForms)
                    .catch((error) => {
                        alertError({error, customMessage: "Could not change status of the form."}); 
                      return false;
                    })
                  if (res) {
                    alertSuccess({title: "Success!", 
                      customMessage: "Changed status of the form."});
                    refreshPatient();
                  }
								}}
							>
								{elem?.active ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "#00F" }} />
								)}
							</Button>
						</Tooltip>
						<Tooltip title="Delete">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setOpenConfirmDialog(2);
                  setSelectedForm(elem);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

  function responsesButtonFormatter(cell, row) {
		const index = formResponses?.findIndex((item) => cell === item._id);
    const elem = (index !== -1)? formResponses[index] : null;
    
		return (
			<>
        
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
              setSelectedResponseForm(elem);
              setOpenEditPatientResponseForm(true);
            }}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes("admin") && (
					<>
						<Tooltip title="Delete">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setOpenConfirmDialog(3);
                  setSelectedResponseForm(elem);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

  async function onSave(form) {
    let newForms = patient?.forms ? [...patient?.forms] : [];
    
    const index = newForms?.findIndex((f) => f.form === form.form);

    if (index === -1) newForms.push(form);
    else newForms[index] = form;

    const res = await actualizeFormsUser(userId, newForms)
      .catch((error) => {
          alertError({error, customMessage: "Could not actualize forms."}); 
        return false;
      })
    
    alertSuccess({
      title: "Success!",
      customMessage: "Patient forms actualized correctly."
    })
    refreshPatient();
    return res;   
  }

  async function onDelete(form) {

    function error(error) {
      alertError({error, customMessage: "Could not delete form."})
      return false;
    }

    let newForms = patient?.forms ? [...patient?.forms] : [];
    
    const index = newForms?.findIndex((f) => f.form === form.form);

    if (index === -1) return error(null);
    else newForms.splice(index, 1);

    const res = await actualizeFormsUser(userId, newForms)
      .catch((error) => {
        return error(error);
      })
    
    alertSuccess({
      title: "Success!",
      customMessage: "Patient form deleted correctly."
    })
    refreshPatient();
    return res;   
  }

  async function onSaveResponse(form) {
    
    const res = await updateFormResponse(form._id, form)
      .catch((error) => {
        alertError({error, customMessage: "Could not update form response."})
        return false;
      })

    alertSuccess({
      title: "Success!",
      customMessage: "Patient form updated correctly!"
    })

    return res;   
  }
  
  async function onDeleteResponse(form) {
    
    const res = await deleteFormResponse(form._id)
    .catch((error) => {
      alertError({error, customMessage: "Could not delete form response."})
      return false;
    })
    
    alertSuccess({
      title: "Success!",
      customMessage: "Patient form deleted correctly."
    })

    fetchResponses();
    return res;   
  }

  function getDataForms(forms) {
    let data = [];

    for (let i = 0; i < forms?.length; ++i) {
      let elem = {};
      const actD = forms[i];
      const allForm = allForms?.find((x) => x._id === actD?.form);
      
      elem.form = actD?.form;
      elem.name = allForm?.name || "No title";
      elem.schedule = actD?.schedule || "No hay schedule";
      elem.active = actD?.active;

      data.push(elem);
    }

    return data;
  }

  function getDataResponsesForms(forms) {

    function sortByUpdatedAt(a, b) {
      const dA = new Date(a.updatedAt), dB = new Date(b.updatedAt);
      if (dA < dB) return 1;
      if (dB < dA) return -1;
      return 0;
    }

    let data = [];

    for (let i = 0; i < forms?.length; ++i) {
      let elem = {};
      const actD = forms[i];
      
      if (!actD?.answered) continue;
      elem._id = actD._id;
      elem.name = actD?.form?.name;
      elem.updatedAt = actD?.answeredAt;
      elem.createdAt = actD?.createdAt;

      data.push(elem);
    }

    data.sort(sortByUpdatedAt);

    return data;
  }

  if (openEditPatientForm) return (
    <EditPatientForm 
    data={selectedForm}
    setOpen={setOpenEditPatientForm}
    newForm={newForm}
    allForms={allForms}
    patientForms={patient?.forms || []}
    onSave={async (form) => {
      return await onSave(form);
    }}
    onDelete={async (form) => {
      return await onDelete(form);
    }}
    />
  )
  else if (openEditPatientResponseForm) return (
    <EditPatientResponseForm 
    data={selectedResponseForm}
    setOpen={setOpenEditPatientResponseForm}
    onSave={async (form) => {
      return await onSaveResponse(form);
    }}
    onDelete={async (form) => {
      return await onDeleteResponse(form);
    }}
    />

  )
	return (
		<>
			<Card>
				<CardHeader title="Forms schedules">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => {
                setSelectedForm(getEmptyForm());
                setOpenEditPatientForm(true);
                setNewForm(true);
              }}
						>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
        <CardBody>
					{!refresh && (<Table data={getDataForms(data)} columns={columns} />)}
        </CardBody>
        <CardHeader title="Forms responses">
          
				</CardHeader>
				<CardBody>
					{!refresh && (<Table data={getDataResponsesForms(formResponses)} columns={responsesColumns} />)}
					<ConfirmDialog
						title={"Are you sure you want to remove this form?"}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
              onDelete(selectedForm);
						}}
					/>
					<ConfirmDialog
						title={"Are you sure you want to remove this form?"}
						open={openConfirmDialog === 3}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
              onDeleteResponse(selectedResponseForm);
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
